import {
    StyledFileItem,
    StyledFileIconContainer,
    StyledFileName,
    StyledFileSize,
    StyledIconButton,
} from './FilesList.styles';
import { IServerJobApplicationEmailFile } from '../../common';
import Grid from '../../base/base-components/Grid/Grid';
import { Icon, Link, Stack } from '../../base';

interface IFilesListProps {
    files: Array<IServerJobApplicationEmailFile>;
    onForward?: (file: IServerJobApplicationEmailFile) => void;
    onRemove?: (index: number) => void;
}

const FilesList = (props: IFilesListProps) => {
    const { files, onForward, onRemove } = props;
    if (!files || files.length === 0) {
        return null;
    }

    return (
        <Grid container spacing={1.5} sx={{ paddingTop: 2 }}>
            {files.map((file, index) => (
                <Grid item xs={12} sm={6} md={4} key={file.id}>
                    <StyledFileItem>
                        <Grid container spacing={1.5} alignItems="center">
                            <Grid item>
                                <StyledFileIconContainer>
                                    <Icon
                                        name="AttachFileIcon"
                                        size={20}
                                        style={{
                                            color: 'white',
                                            transform: 'rotate(45deg)',
                                        }}
                                    />
                                </StyledFileIconContainer>
                            </Grid>
                            <Grid
                                item
                                xs
                                sx={{ minWidth: 0 }}
                            >
                                <Stack spacing={0.5}>
                                    <StyledFileName>
                                        {file.file_name}
                                    </StyledFileName>
                                    <StyledFileSize>
                                        {file.size} MB
                                    </StyledFileSize>
                                </Stack>
                            </Grid>
                            <Grid
                                item
                                alignSelf={
                                    onRemove ? 'flex-start' : 'flex-end'
                                }
                            >
                                <Grid container>
                                    {onRemove ? (
                                        <StyledIconButton
                                            onClick={() => onRemove(index)}
                                        >
                                            <Icon
                                                name="CloseIcon"
                                                size={18}
                                            />
                                        </StyledIconButton>
                                    ) : (
                                        <>
                                            <Link
                                                href={file.file_url}
                                                target="_blank"
                                                download
                                            >
                                                <StyledIconButton>
                                                    <Icon
                                                        name="FileDownloadOutlinedIcon"
                                                        size={18}
                                                    />
                                                </StyledIconButton>
                                            </Link>
                                            {onForward && (
                                                <StyledIconButton
                                                    onClick={() =>
                                                        onForward(file)
                                                    }
                                                >
                                                    <Icon
                                                        name="ShortcutOutlinedIcon"
                                                        size={18}
                                                    />
                                                </StyledIconButton>
                                            )}
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </StyledFileItem>
                </Grid>
            ))}
        </Grid>
    );
};

export default FilesList;
